<template lang="pug">
div
  .ActionCompletPreIngreso
    div
      //- BOTON COMPLETAR PRE-INGRESO
      //-Boton para completar preingreso del cliente, como administrador
    router-link(:to="`/crear-orden-preingreso/${ot.ot}`")
      button.change-button(
        :disabled="disabled || loading"
        @click="handleClick"
        )
        | Completar Pre-Ingreso
        b-spinner(v-if="loading" class="ml-2" variant="white" small)
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionCompletPreIngreso',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    ...mapActions('OTStore', ['getOT']),
    handleClick() {
      // Activar loading durante la navegación
      this.startLoading()
      // El loading se detendrá cuando el componente se desmonte o después de un timeout
      setTimeout(() => {
        this.stopLoading()
      }, 1000)
    },
    showModal() {
      this.modal = true
    },
    hideModal() {
      this.modal = false
    },
  },
  computed: {},
}
</script>

<style lang="sass" scoped></style>
